import { useParams } from 'react-router-dom';
import { useFetchModelScenarios } from '../../../../hooks/useFetchModelScenarios';

export const useAnalogueModelHasScenario = () => {
  const { modelId } = useParams<{ modelId: string }>();
  const { data: scenarios } = useFetchModelScenarios(modelId);
  return !!scenarios && scenarios.length > 0;
};
